export default (firstName, middleName, lastName) => {
  if (middleName && middleName.length > 0) {
    return ` ${firstName} ${middleName} ${lastName}`;
  }

  return ` ${firstName} ${lastName}`;
};
